import { useSalescoreAuth } from '@salescore/client-base'
import { Logo } from '@salescore/client-common'
import { SignInByOauthCode, SignInBySalesforceSession } from '@salescore/client-feature-setting'
import { getQueryParameter } from '@salescore/frontend-common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { isNotNull } from 'effect/Predicate'
import type { ReactElement } from 'react'

import { SignIn } from '../components/SignIn.tsx'

//
// 組織を問わないログインページ。
// 2023/01より、o/[oid]/sign_inの利用を推奨。
// この画面に遷移するのは、ユーザーへ案内するログインURLが不適切だったときか、
// 以下のロジックにある通りSalesforceからのログインでの利用のみの想定
//

const Page = (): ReactElement => {
  const { isSignedInBySalescoreAuth } = useSalescoreAuth()
  const sfSessionId = getQueryParameter('sfSessionId')
  const sfEnterpriseServerUrl = getQueryParameter('sfEnterpriseServerUrl')
  const oauthCode = getQueryParameter('oauthCode')
  const provider = getQueryParameter('provider')
  const state = getQueryParameter('state')
  const navigate = useNavigate()
  const redirectToRoot = (): void => {
    void navigate({ to: '/' })
  }
  const [sfInstanceUrl] = sfEnterpriseServerUrl?.split('/services/') ?? []
  if (sfSessionId !== null && sfSessionId !== '' && sfInstanceUrl !== undefined && sfInstanceUrl !== '') {
    return (
      <SignInBySalesforceSession
        sessionToken={sfSessionId}
        instanceUrl={sfInstanceUrl}
        redirectToRoot={redirectToRoot}
      />
    )
  }
  if (oauthCode !== null && oauthCode !== '' && provider !== null && provider !== '' && isNotNull(state)) {
    return <SignInByOauthCode oauthCode={oauthCode} provider={provider} state={state} redirectToRoot={redirectToRoot} />
  }
  // リダイレクト中にチラつくのを防ぐ
  if (isSignedInBySalescoreAuth) {
    return <></>
  }

  return (
    <div className="flex size-full flex-col items-center justify-center text-center align-middle">
      <div className="mb-8 w-64">
        <Logo />
      </div>
      <div style={{ width: 320, maxWidth: '100%', maxHeight: 500 }}>
        <SignIn />
      </div>
    </div>
  )
}

export const Route = createFileRoute('/sign_in')({
  component: Page,
})
